import { createContext } from 'react';
import { StreamingMetaApiConnectionInstance } from 'metaapi.cloud-sdk';

export type DefaultValuesContextType = {
  accountId?: string;
  connection?: StreamingMetaApiConnectionInstance;
};

const defaultValues = {
  connection: undefined,
  accountId: '',
};

export const Context = createContext<DefaultValuesContextType>(defaultValues);

export const { Provider } = Context;
